





















































	import {
		Component,
		Vue
	} from "vue-property-decorator";
  import { Button, Dialog, Toast } from "vant";
  import customField from "@/components/customField/index.vue";

	@Component({
		name: "stocksBroker",
		components: {
      customField,
		  [Button.name]: Button,
      [Dialog.Component.name]: Dialog.Component,
		}
	})
	export default class stocksBroker extends Vue {
    isShowOpenDialog = false;
    openTipsEmail = "cs@goingf.hk";
		get bgColor() {
			return this.$store.getters["common/bgColor"];
		}
		stock() {
      (this as any).$apis.getAccountSituation().then(res =>{
        // open_method：1:个人开户 ，2:机构开户
        if(res && res.open_method == 1){
          (this as any).$router.push({
            path: '/open-account/accountProfile?openType=3'
          })
        }else{
        // 机构开户 需要提示
          (this as any).isShowOpenDialog = true;
        }
      });



		}
    onCopySuccess(){
      Toast(this.$t("funds.into.others[6]"));
    }

	}
